import { ManualAnalysisPanelState, RootState } from "@/@types/vuex";
import { GetterTree } from "vuex";

const getters: GetterTree<ManualAnalysisPanelState, RootState> = {};

export default getters;
